import { LanguageContext } from "context/LanguageContext"
import dynamic from "next/dynamic"
import { memo, useContext } from "react"

const WiFiAnimation = dynamic(() => import("../WiFiAnimation"), {
  ssr: false,
  loading: () => (
    <div className="w-4 h-4 flex items-center justify-center">
      <div className="w-2 h-2 bg-warning rounded-full animate-ping" />
    </div>
  ),
})

interface TitleWithLiveDotProps {
  color?: "primary" | "light"
  alignText?: "left" | "center" | "right"
  mobileTextSize?: "extra-large" | "ultra-large"
}

function TitleWithLiveDot({
  color = "primary",
  alignText = "center",
  mobileTextSize = "extra-large",
}: TitleWithLiveDotProps) {
  const { useTranslation: t } = useContext(LanguageContext)
  const marketplace = t("marketplace") // "live Training"
  const [firstWord, ...rest] = marketplace.split(" ")

  let textColor = "text-primary"
  if (color === "light") {
    textColor = "text-white"
  }

  let textAlign = "text-center"
  if (alignText === "left") {
    textAlign = "text-left"
  } else if (alignText === "right") {
    textAlign = "text-right"
  }

  let textSizeMobile = "text-xl"
  if (mobileTextSize === "ultra-large") {
    textSizeMobile = "text-2xl"
  }

  return (
    <h1 className={`${textSizeMobile} sm:text-[48px] leading-tight font-semibold ${textColor} ${textAlign}`}>
      {t("live_training")}{" "}
      <span className="text-[#FFBE0B] leading-tight inline-flex flex-wrap items-end">
        {firstWord === "live" ? (
          <span 
            className="relative" 
            translate="no" 
            data-translate="no"
            style={{ fontFeatureSettings: "\"liga\" 0" }} // Disable ligatures
          >
            <span>L</span>
            <span className="relative inline-block">
              <span>ı</span> {/* ← i without a dot */}
              <span className="absolute bottom-full left-1/2 -translate-x-1/2 -mb-1.5 sm:-mb-[14px] pl-[1px] sm:pl-[3px] pointer-events-none">
                <WiFiAnimation />
              </span>
            </span>
            <span>v</span>
            <span>e</span>
          </span>
        ) : (
          <span>{firstWord}</span>
        )}

        {rest.length > 0 && <span>&nbsp;{rest.join(" ")}</span>}
      </span>
    </h1>
  )
}


export default memo(TitleWithLiveDot)